import React, { useEffect } from "react";
import MyButton1 from "./CustomComponents/MyButton1";
import {
  CssBaseline,
  Stack,
  IconButton,
  Typography,
  Container,
} from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";

import "./eventComponent/EventTabs/EventTabs.css";
import { homePagePath } from "../constant";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";

export const Cancellation_Refund_Policy = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const backtoHome = () => {
    navigate(isLoggedIn ? "/dashboard" : homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />

      <div className={`main-container ${!isLoggedIn ? "no-auth" : ""}`}>
        <div className="event-service-head-inner-policy">
          {/* <IconButton
                  onClick={backtoHome}
                  style={{
                    backgroundColor: "#0cc0df",
                    color: "#fff",
                    padding: "8px",
                  }}
                >
                  <KeyboardBackspaceOutlinedIcon />
                </IconButton> */}
          <div>
            <button
              className="back-to-services-btn"
              onClick={backtoHome}
            >
              <i className='pi pi-arrow-left'></i> Back to Dashboard
            </button>

          </div>


        </div>
        <div className="center-heading">
          <h1>Cancellation & Refund Policy</h1>
        </div>
        <div className="frontend-container">
          <div className="event-form-inner">

            <div className="event-form-body alter full">
              <div className="event-form-content">
                <p>Last updated on Jul 3 2025</p>
                <p style={{ whiteSpace: "pre-line", lineHeight: 1.7 }}>


                  THURENT TECH SERVICES PRIVATE LIMITED believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
                  <br />
                  <br />
                  • Cancellations will be considered only if the request is made within 2 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
                  <br />
                  <br />
                  • THURENT TECH SERVICES PRIVATE LIMITED does not accept cancellation requests for perishable items like flowers, eatables, etc. However, refund/replacement can be made if the customer establishes that the quality of the product delivered is not good.
                  <br />
                  <br />
                  • In case of receipt of damaged or defective items, please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and confirmed the same at their end. This should be reported within 2 days of receipt of the products.
                  <br />
                  <br />
                  • If you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our Customer Service within 2 days of receiving the product. The Customer Service Team will review the complaint and take an appropriate decision.
                  <br />
                  <br />
                  • For products with manufacturer warranties, please contact the manufacturer directly.
                  <br />
                  <br />
                  • In case of any refunds approved by THURENT TECH SERVICES PRIVATE LIMITED, it will take 3–5 working days for the refund to be processed to the customer.
                </p>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",       // Ensure full width
                  padding: "0 20px"    // Optional: Add horizontal padding
                }}>
                  <p style={{ margin: 0 }}>Email: nick@thurent.com</p>
                  <p style={{ margin: 0 }}>Phone: 74167 34499</p>
                  <p style={{ margin: 0 }}>Website: www.thurent.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ConfirmDialog />
    </div>
  );
};

export default Cancellation_Refund_Policy;
